import React from 'react';
import TransactionSuccessModal from '../UnlockHeroProvider/TransactionSuccessModal';
import TransactionFailureModal from '../UnlockHeroProvider/TransactionFailureModal';
import { AppError } from 'src/redux/types';
import { useTypedDispatch } from 'src/redux/utils';
import { fetchHeroDetail, fetchRentalConfig, mintHero, prepareMintHero } from 'src/redux/actions';
import { useConfirmOpenWalletConnect } from 'src/Components/WalletConnectConfirmProvider';
var MintHeroModalName;

(function (MintHeroModalName) {
  MintHeroModalName["TRANSACTION_SUCCESS"] = "transaction_success";
  MintHeroModalName["TRANSACTION_FAILURE"] = "transaction_failure";
})(MintHeroModalName || (MintHeroModalName = {}));

const MintHeroContext = /*#__PURE__*/React.createContext({
  mintHero: () => Promise.resolve()
});

const MintHeroProvider = ({
  children
}) => {
  const dispatch = useTypedDispatch();
  const {
    confirmOpenWalletConnect
  } = useConfirmOpenWalletConnect();
  const [hero, setHero] = React.useState(null);
  const [modal, setModal] = React.useState(null);
  const [error, setError] = React.useState(AppError.NO_ERROR);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setHero(null);
    setModal(null);
  }, []);
  const startMintHero = React.useCallback(async hero => {
    setHero(hero);
    const preparedData = await dispatch(prepareMintHero({
      heroId: hero.hero.id
    }));
    confirmOpenWalletConnect(async () => {
      const {
        error
      } = await dispatch(mintHero(preparedData));

      if (!error) {
        openModal(MintHeroModalName.TRANSACTION_SUCCESS);
      } else {
        openModal(MintHeroModalName.TRANSACTION_FAILURE);
        setError(error);
      }
    });
  }, [dispatch, openModal]);
  const context = React.useMemo(() => {
    return {
      mintHero: startMintHero
    };
  }, [startMintHero]);

  const renderModal = () => {
    switch (modal) {
      case MintHeroModalName.TRANSACTION_SUCCESS:
        return /*#__PURE__*/React.createElement(TransactionSuccessModal, {
          onClose: () => {
            closeModal();

            if (hero) {
              dispatch(fetchHeroDetail(hero === null || hero === void 0 ? void 0 : hero.hero.id));
              dispatch(fetchRentalConfig());
            }
          }
        });

      case MintHeroModalName.TRANSACTION_FAILURE:
        return /*#__PURE__*/React.createElement(TransactionFailureModal, {
          error: error,
          onClose: () => {
            closeModal();

            if (hero) {
              dispatch(fetchHeroDetail(hero === null || hero === void 0 ? void 0 : hero.hero.id));
              dispatch(fetchRentalConfig());
            }
          }
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(MintHeroContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useMintHero = () => {
  const {
    mintHero
  } = React.useContext(MintHeroContext);
  return {
    mintHero
  };
};
export default MintHeroProvider;